import {
  ArnConditionExecResults,
  ArnConditionsPayload,
  ArnValidConditionConfig,
  ObjectUtil,
  UrlUtil,
} from '@arianee/arn-types';
import { ArnHttpService } from '../http';
import { ArnAuthService } from '../auth';
import { ArnAbstractConditionService } from './ArnAbstractConditionService';
import { ArnErc721ConditionService } from './erc721/ArnErc721ConditionService';
import { DefaultErc721ConditionService } from './erc721/DefaultErc721ConditionService';
import {
  ArnArianeeNftConditionService,
  DefaultArianeeNftConditionService,
} from './arianee';
import { ArnUserConditionService, DefaultUserConditionService } from './user';
import { ArnHttpConditionService, DefaultHttpConditionService } from './http';
import { ArnConditionExecutionOptions } from './ArnConditionService';

/**
 * Checks conditions through HTTP calls towards an ARN Server.
 */
export class DefaultConditionService extends ArnAbstractConditionService {
  readonly arianee: ArnArianeeNftConditionService;
  readonly erc721: ArnErc721ConditionService;
  readonly user: ArnUserConditionService;
  readonly http: ArnHttpConditionService;

  constructor(
    protected _http: ArnHttpService,
    protected auth: ArnAuthService,
    protected config: ArnValidConditionConfig
  ) {
    super();
    this.arianee = new DefaultArianeeNftConditionService(this);
    this.erc721 = new DefaultErc721ConditionService(this);
    this.user = new DefaultUserConditionService(this);
    this.http = new DefaultHttpConditionService(this);
  }

  override async execute(
    payload: ArnConditionsPayload,
    options?: ArnConditionExecutionOptions
  ): Promise<ArnConditionExecResults> {
    let results = await super.execute(payload, options);
    const nothingFromCache = results.executions.length <= 0;
    if (nothingFromCache) {
      const authorized = ObjectUtil.isSet(options?.authorized)
        ? options?.authorized
        : true;
      const url = UrlUtil.join(
        this.config.execute.url,
        payload.and.length === 1 ? payload.and[0].opts.name ?? '' : ''
      );
      results = await (authorized
        ? this._http.sendAuthorizedJson<ArnConditionExecResults>(
            this.auth,
            url,
            payload
          )
        : this._http.sendJson<ArnConditionExecResults>(url, payload));
      this._context?.cache.set(payload, results);
    }
    return results;
  }
}
